import { useEffect, useState } from "react";
import { Check, X, Swords } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function ChallengesAdmin() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/challenges").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await api.put(`/admin/challenges/${id}/status`, { status }); toast.success(status === "approved" ? "Approved & invite emailed" : "Updated"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  const badge = (s) => ({ pending: "text-amber-400", approved: "text-emerald-400", accepted: "text-violet-300", declined: "text-red-400" }[s] || "text-slate-400");

  return (
    <div>
      <h1 className="font-display font-extrabold text-3xl mb-1">Challenges</h1>
      <p className="text-slate-400 mb-6">Approve team-vs-team challenge invites before we email them.</p>
      <div className="space-y-3">
        {rows.map((c) => (
          <div key={c.id} className="rounded-2xl border border-white/10 bg-[#131a29] p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid={`challenge-${c.id}`}>
            <Swords className="h-6 w-6 text-violet-400 shrink-0" />
            <div className="flex-1">
              <div className="font-semibold">{c.challenger_team} <span className="text-slate-500">→</span> {c.challenged_name}</div>
              <div className="text-xs text-slate-400">{c.game_name} · code {c.invite_code} {c.message && `· "${c.message}"`}</div>
              <div className="text-xs text-slate-500 mt-1">{c.challenger_email} → {c.challenged_email}</div>
            </div>
            <div className={`text-sm font-medium ${badge(c.status)}`}>{c.status}{c.accepted && " · accepted"}</div>
            {c.status === "pending" && (
              <div className="flex gap-2">
                <Button size="sm" onClick={() => setStatus(c.id, "approved")} data-testid={`approve-${c.id}`} className="bg-emerald-600 hover:bg-emerald-500"><Check className="h-4 w-4" /></Button>
                <Button size="sm" variant="ghost" className="text-red-400" onClick={() => setStatus(c.id, "declined")} data-testid={`decline-${c.id}`}><X className="h-4 w-4" /></Button>
              </div>
            )}
          </div>
        ))}
        {rows.length === 0 && <p className="text-slate-500">No challenges yet.</p>}
      </div>
    </div>
  );
}
